import { createFileRoute } from '@tanstack/react-router'
import { FounderLayout } from '../../../../components/founder-layout'
import { HomePage } from '../../../../features/home/components/home-page'
import { useInviteAcceptance } from '../../../../hooks/use-invite-acceptance'

export const Route = createFileRoute('/app/startup/$id/')({
  component: StartupDashboardPage,
})

/**
 * Home.
 *
 * One focus card, resolved fresh on every load, showing the single most
 * important thing right now. It replaces a dashboard that inferred what to show
 * from loosely related queries and stayed cheerful when things broke — on the
 * prod extract four campaigns sat dead for weeks while this page told their
 * founders the campaign was live.
 */
function StartupDashboardPage() {
  // Consumes ?invite=<token> when a founder lands here from an invite email.
  // Home is one of only two mount points for this, so it has to stay.
  useInviteAcceptance()
  const { id: startupId } = Route.useParams()

  return (
    <FounderLayout activeNav="Home">
      <HomePage startupId={startupId} />
    </FounderLayout>
  )
}
